var _path, _circle, _path2, _circle2, _path3, _circle3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBusinessmen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.25v-4.5c0-.26.03-.51.1-.75H1.75C.79 1 0 1.79 0 2.75v4.5C0 8.21.79 9 1.75 9h.37l1.28 1.7c.14.18.35.29.57.3H4c.22 0 .42-.09.56-.26l1.5-1.71A3.286 3.286 0 014.5 6.25zM22.25 1H19.4c.07.24.1.49.1.75v4.5c0 1.17-.63 2.2-1.56 2.78l1.5 1.71c.14.17.34.26.56.26h.03c.22-.01.43-.12.57-.3L21.87 9h.38C23.21 9 24 8.21 24 7.25v-4.5C24 1.79 23.21 1 22.25 1zM12 10h-.028a.753.753 0 01-.572-.3L10.125 8H7.75C6.785 8 6 7.215 6 6.25v-4.5C6 .785 6.785 0 7.75 0h8.5C17.215 0 18 .785 18 1.75v4.5C18 7.215 17.215 8 16.25 8h-2.16l-1.526 1.744A.748.748 0 0112 10z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 15,
    r: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67 18.4A4.19 4.19 0 005 21.75V22H.75c-.41 0-.75-.34-.75-.75v-.5C0 19.23 1.23 18 2.75 18h2.5c.52 0 1.01.15 1.42.4z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 15,
    r: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20.75v.5c0 .41-.34.75-.75.75H19v-.25c0-1.37-.66-2.59-1.67-3.35.41-.25.9-.4 1.42-.4h2.5c1.52 0 2.75 1.23 2.75 2.75z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14.5,
    r: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 19h-5.5a2.752 2.752 0 00-2.75 2.75v1.5c0 .414.336.75.75.75h9.5a.75.75 0 00.75-.75v-1.5A2.752 2.752 0 0014.75 19z"
  })));
}

export default SvgBusinessmen;